import { Tbl, DT, n } from "./SkuParts";

const BUCKETS = [["physical", "Physical"], ["free", "Available"], ["reserved", "Reserved"], ["picked", "Picked"], ["packed", "Packed"], ["hold", "QC Hold"],
  ["quarantine", "Quarantine"], ["damaged", "Damaged"], ["rejected", "Rejected"], ["unlocated", "Unlocated / Staging"], ["in_transit", "In Transit"], ["in_production", "WIP"]];

export default function StockDetailsTab({ d }) {
  const s = { ...d.stock, in_transit: d.in_transit };
  return (
    <div className="space-y-4" data-testid="sku-tab-stock-details">
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-2" data-testid="sku-stock-summary">
        {BUCKETS.map(([k, label]) => (
          <div key={k} className="bg-card border border-border rounded-lg p-3" data-testid={`sku-bucket-${k}`}>
            <p className="text-[9px] font-mono uppercase tracking-widest text-muted-foreground">{label}</p>
            <p className="metric text-lg font-extrabold mt-0.5">{n(s[k])}</p>
          </div>
        ))}
      </div>
      <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Complete stock history · ledger is read-only — corrections only via adjustment / transfer / reversal</p>
      <Tbl testid="sku-ledger-table" empty="No movements yet" head={["Date / Time", "Transaction", "Reference", "Qty", "Bucket", "Warehouse", "Location", "Batch", "User", "Dept", "Prev → Closing"]}>
        {d.ledger.map((l, i) => (
          <tr key={l.ledger_id || l.entry_id || `${l.at}-${i}`} className="border-b border-border/50" data-testid={`sku-ledger-row-${i}`}>
            <td className="px-3 py-2"><DT v={l.at} /></td>
            <td className="px-3 py-2 text-[10px] font-mono uppercase">{l.transaction_type}</td>
            <td className="px-3 py-2 metric text-xs">{l.reference || "—"}</td>
            <td className={`px-3 py-2 metric font-bold ${l.qty_out ? "text-signal-red" : l.qty_in ? "text-signal-green" : ""}`}>{l.qty_in ? `+${n(l.qty_in)}` : l.qty_out ? `−${n(l.qty_out)}` : n(l.quantity)}</td>
            <td className="px-3 py-2 text-[10px] font-mono">{(l.from_bucket || l.to_bucket) ? `${l.from_bucket || "—"} → ${l.to_bucket || "out"}` : "—"}</td>
            <td className="px-3 py-2 text-xs">{l.warehouse || "—"}</td>
            <td className="px-3 py-2 metric text-xs">{l.location || l.to_location || l.from_location || "—"}</td>
            <td className="px-3 py-2 text-xs">{l.batch || "—"}</td>
            <td className="px-3 py-2 text-xs">{l.user_name}</td>
            <td className="px-3 py-2 text-xs">{l.department || "—"}</td>
            <td className="px-3 py-2 metric text-xs">{l.prev_balance != null ? `${n(l.prev_balance)} → ${n(l.new_balance ?? l.balance)}` : n(l.balance)}</td>
          </tr>
        ))}
      </Tbl>
    </div>
  );
}
